import React from "react";
import { ReactComponent as TickIcon } from "assets/img/svg/TickIcon.svg"; // same icon used in system
import {
  getFormattedAmount,
  getFormattedDate,
} from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import ChequeDetails from "../../../cheque-management/deposites/components/ChequeDetails";

const tickStyle = {
  background: "#05945B",
  borderRadius: "50%",
  height: "30px",
  width: "30px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const fontColor = {
  color: "#07794C",
};

const CheckDateExtensionSuccess = ({
  details = {}, // { totalReceipts, totalAmount, depositSlipId }
  onClose = () => {}, // Go to dashboard / close modal
  onView = () => {}, // View deposit slip
  row = {},
}) => {
  const { psid = "--", amount = 0, depositSlipId = "--" } = details;

  return (
    <div style={{ minWidth: "400px" }}>
      {/* Header */}
      <div className="d-flex align-items-center gap-3 mb-4">
        <div style={tickStyle}>
          <TickIcon />
        </div>
      </div>

      <ChequeDetails
        psid={row?.psid}
        chequeNumber={row?.referenceNumber}
        chequeAmount={(row?.amountCollected)}        chequeDate={getFormattedDate(row?.paymodeDate)}
      />
        <div className="d-flex justify-content-between regular-body mb-2">
        <div>New Cheque/DD date</div>
        <div className=" text-dark text-bold">{getFormattedDate(row?.newPaymodeDate) || ""}</div>
      </div>
    </div>
  );
};

export default CheckDateExtensionSuccess;
